import * as Arr from 'fp-ts/Array';
import * as ChainRec from 'fp-ts/ChainRec';
import * as E from 'fp-ts/Either';
import { pipe } from 'fp-ts/lib/function';
import * as O from 'fp-ts/Option';
import * as St from 'fp-ts/State';
import { match, P } from 'ts-pattern';
import * as Sel from '../configuration/selections';
import * as IP from '../inspirationProduct';
import * as Pr from '../product';
function handleEmptyArray(st) {
    return pipe(O.Do, O.bind('possibleVariants', () => O.fromNullable(st.possibleVariants)), O.bind('id', ({ possibleVariants }) => pipe(possibleVariants, Arr.head, O.map(Pr.id))), O.map(({ id }) => St.of({
        _tag: 'FinalResult',
        selectedProductId: O.some(id),
    })), O.getOrElse(() => St.of({
        _tag: 'FinalResult',
        selectedProductId: O.none,
    })));
}
function handleProposalArray(st) {
    return ([head, ...rest]) => {
        const matchingVariants = pipe(st.possibleVariants, Arr.filter(variant => {
            const variantSelections = Sel.getPropertySelectionsForProduct(variant);
            return Sel.isSubset(head, variantSelections);
        }));
        const success = matchingVariants.length > 0;
        return pipe(St.modify(_st => ({
            ..._st,
            proposal: rest,
            validSelections: success
                ? Sel.concat(head, _st.validSelections)
                : _st.validSelections,
            possibleVariants: success ? matchingVariants : _st.possibleVariants,
        })), St.chain(() => St.of({ _tag: 'IntermediateResult' })));
    };
}
const _step = pipe(St.get(), St.chain(st => {
    return match(st.proposal)
        .with([], () => handleEmptyArray(st))
        .with([P._, ...P.array()], handleProposalArray(st))
        .exhaustive();
}));
/**
 * Resolve only checks a proposal Selection by Selection, with a Selections being atomic. This could cause
 * trouble if you wish to have the User's initial Selections preserved if this conflicts with the user's
 * Initial choice. Therefore, it may be useful to add extra Selections to represent this requirement if necessary.
 */
export const resolve = (initialInspirationProductGroup, proposal) => ChainRec.tailRec({
    initialInspirationProductGroup: initialInspirationProductGroup,
    proposal,
    possibleVariants: IP.variants(initialInspirationProductGroup),
    validSelections: Sel.empty(),
}, st => {
    const [result, state] = _step(st);
    if (result._tag === 'FinalResult') {
        return E.right(result);
    }
    else {
        return E.left(state);
    }
});
